export default "__VITE_ASSET__B6Fq4U$H__"